/**
 * Name: Delete songs Reducer
 * Author: @Gaurav
 * Date: 21-07-2021
 */
export default function reducer(
  state = {
    status: 'uninitiated',
    result: {},
  },
  action
) {
  switch (action.type) {
    case 'DELETE_PLAYLIST_INITIATED': {
      return { ...state, status: 'initiated' };
    }
    case 'DELETE_PLAYLIST_SUCCESS': {
      return { ...state, status: 'success', result: action.payload };
    }
    case 'DELETE_PLAYLIST_FAILED': {
      return { ...state, status: 'failed', result: action.payload };
    }
    default: {
      return state;
    }
  }
}
